import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import Header from "../../../../Componets/Header";
import forms from "../../../../Data/Forms/Inventory/Transfer/forms";
import headers from "../../../../Data/Forms/Inventory/Transfer/headers";
import inventory from "../../../../Data/inventory.json";
import branches from "../../../../Data/branch.json";
import products from "../../../../Data/products.json";
import Transfertable from "../../../../Componets/Transfertable";

const InventoryTransferForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  const [values, setValues] = useState(forms);

  const formdata = async (data) => {
    if (data?.status) {
    }
  };

  const handleData = (item) => {};

  const get_product = (id) => {
    let product = "";
    products?.map((value, index) => {
      if (id == value?.id) {
        product = value?.name;
      }
    });

    return product;
  };

  // const fetchData = async () => {
  //   let inventory_options = [];

  //   inventory?.map((value, index) => {
  //     inventory_options?.push({
  //       value: get_product(value?.product) + " (" + value?.batch_number + " )",
  //       label: get_product(value?.product) + " (" + value?.batch_number + " )",
  //     });
  //   });

  //   let branches_options = [];

  //   branches?.map((value, index) => {
  //     branches_options?.push({
  //       value: value?.name,
  //       label: value?.name,
  //     });
  //   });

  //   values[0].options[1].form.options = inventory_options;
  //   values[1].options[0].form.options = branches_options;
  //   setValues([...values]);
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  const fetchData = async () => {
    let branches_options = [];
    branches?.map((value, index) => {
      branches_options?.push({
        value: value?.name,
        label: value?.name,
      });
    });

    let item_options = [];
    inventory?.map((value, index) => {
      item_options?.push({
        value: value?.batch_number,
        label: get_product(value?.product) + " (" + value?.batch_number + ") ",
      });
    });

    let product_options = [];
    inventory?.map((value, index) => {
      product_options?.push(value);
    });

    values[1].options[0].form.options = branches_options;
    values[3].options[0].form = <Transfertable />;
    // values[3].options[0].form.options = product_options;
    // values[3].options[0].form.body[0].Description.form.options = item_options;
    setValues([...values]);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header header={headers}>
      <Forms width={70} form={values} setForm={setValues} formdata={formdata} />
    </Header>
  );
};

export default InventoryTransferForm;
